import { ErrorHandler, NgModule, LOCALE_ID } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClient, HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgApexchartsModule } from 'ng-apexcharts';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

// icons
import { TablerIconsModule } from 'angular-tabler-icons';
import * as TablerIcons from 'angular-tabler-icons/icons';

//Import all material modules
import { MaterialModule } from './material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';



import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { StoreModule } from '@ngrx/store';
import { authReducer } from './store/auth/auth.reducer';
import { LoadingService } from './services/loading.service';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { GlobalErrorHandler } from './handlers/global-error-handler';

import { provideEnvironmentNgxMask } from 'ngx-mask';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepickerIntl } from '@angular/material/datepicker';
import { PtBrMatDatepickerIntl } from './utils/PtBrMatDatepickerIntl';
import { EffectsModule } from '@ngrx/effects';
import { AuthEffects } from './store/auth/auth.effects';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { LoadingComponent } from './components/loading/loading.component';
import { NgxCurrencyDirective } from 'ngx-currency';
import { AgGridModule } from 'ag-grid-angular';
import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import localePtExtra from '@angular/common/locales/extra/pt';
import { NotaFiscalDetailDialogComponent } from './components/nota-fiscal-detail-dialog/nota-fiscal-detail-dialog.component';

export function HttpLoaderFactory(http: HttpClient): any {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
registerLocaleData(localePt, 'pt-BR', localePtExtra);

@NgModule({ declarations: [
        AppComponent,
        LoadingComponent,
        NotaFiscalDetailDialogComponent,
    ],
    exports: [TablerIconsModule],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
        MatProgressSpinnerModule,
        TablerIconsModule.pick(TablerIcons),
        NgApexchartsModule,
        NgxCurrencyDirective,
        StoreModule.forRoot({ auth: authReducer }),
        EffectsModule.forRoot([AuthEffects]),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient],
            },
        }),
        AgGridModule], providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true,
        },
        { provide: ErrorHandler, useClass: GlobalErrorHandler },
        { provide: LOCALE_ID, useValue: 'pt-BR' },
        LoadingService,
        provideEnvironmentNgxMask(),
        { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
        { provide: MatDatepickerIntl, useClass: PtBrMatDatepickerIntl },
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule {}
